import * as React from 'react';
import * as styles from './RequestDemandBlockWrapper.css';

export const RequestDemandBlockWrapper: React.FC = ({ children }) => <div className={styles['root']}>{children}</div>;

RequestDemandBlockWrapper.displayName = 'RequestDemandBlockWrapper';
